import { ListSourceType } from "@/enum/list.enum";

/**
 * The seven source types that offer event-based outreach (PREC-3687 D6, from the ticket
 * description). They are the list kinds where "everyone here is going to the same thing" is a
 * sensible premise — an uploaded attendee sheet, a LinkedIn event, a hand-built list — so a shared
 * event name, date range and meeting slot are worth carrying across every campaign on the list.
 *
 * A `TRACKER` is the counter-example and deliberately absent: its leads surface one at a time for
 * unrelated reasons, so there is no single event to hang them on.
 */
const EVENT_OUTREACH_SOURCE_TYPES: ReadonlySet<string> = new Set<string>([
	ListSourceType.CSV_ENRICHMENTS,
	ListSourceType.LI_SN,
	ListSourceType.LI_PEOPLE,
	ListSourceType.LI_EVENTS,
	ListSourceType.LI_POST,
	ListSourceType.EMPTY,
	ListSourceType.CUSTOM_EVENTS,
]);

/**
 * Whether this list type can use event outreach at all.
 *
 * Two call sites, and they must agree: the General section renders `EventOutreachStrip` only when
 * this is true, and *Create new campaign* skips the Event-vs-Regular branch modal when it is false
 * (there is no event branch to offer, so asking would be a dead end).
 *
 * This is only the *type* gate. Whether the strip then shows a configured event is the strip's own
 * `list_event`-row gating from PREC-3520, which is unchanged (D7).
 */
export function isEventOutreachEligible(sourceType: string | null | undefined): boolean {
	return sourceType ? EVENT_OUTREACH_SOURCE_TYPES.has(sourceType) : false;
}
